document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  const contactPosted = urlParams.get("contact_posted");
  const formIdFromHash = window.location.hash.substring(1);

  if (!contactPosted || !formIdFromHash) return;

  document
    .querySelectorAll<HTMLElement>(".contact__form")
    .forEach((formElement) => {
      const status = formElement.querySelector<HTMLElement>(".form-status");
      status.classList.toggle("hidden", formElement.id !== formIdFromHash);
    });
});
